/** The kind of in-progress change on a tag. */
export var ChangeMode = /*#__PURE__*/function (ChangeMode) {
  ChangeMode["ADD"] = "add";
  ChangeMode["EDIT"] = "edit";
  ChangeMode["DELETE"] = "delete";
  return ChangeMode;
}({});

/** A single tag entry held in the staged-edit store. */

/** All staged tag entries keyed by tag_id. */

/** Shape of the patient tags Zustand store. */